import { Icon } from '@mui/material';
import ChatComponent from '../chatDashboard/ChatComponent';
import './VisualizerModal.scss';

const VisualizerModal = ({
    row
}) =>{
    const info = row.options;
    return(
        <>
        <section>
                <header>
                    <h2>Info Chat</h2>
                </header>
            </section>
            <div className='confirmation-Warning-subtitle'>
                <p>
                    {info.map((row, index) => (
                        <tr key={index}>
                            <td>{row}</td>
                        </tr>
                        ))}</p>
            </div>
            <div className='chat-container visualizer-chat-container'>
                <h1>Chat Online</h1>
                <ChatComponent user_Type={'support'}/>
            </div>
        </>
    );
}

export default VisualizerModal;